module.exports = __webpack_public_path__ + "static/media/t11.82be95f2.png";